module.exports = __webpack_public_path__ + "assets/scoober-logo-icon-3fdcf7.svg";